import { Component, Input } from '@angular/core';

import { statusProjetadoEmNegociacao } from '../../cliente-analise-mercado-status-projetado';
import { ClienteAnaliseMercadoStatusProjetadoPipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-projetado-badge-pill-em-negociacao',
    templateUrl: './cliente-analise-mercado-status-projetado-badge-pill-em-negociacao.component.html',
    styleUrls: ['./cliente-analise-mercado-status-projetado-badge-pill-em-negociacao.component.less']
})
export class ClienteAnaliseMercadoStatusProjetadoBadgePillEmNegociacaoComponent {
    /** ID Etapa de Negociação da Projeção */
    @Input() idEtapaNegociacaoProjecao: number = null;
    /** Nome Etapa de Negociação da Projeção */
    @Input() nomeEtapaNegociacaoProjecao: string = null;
    /** Title para exibir no badge */
    @Input() title: string = null;

    constructor(private clienteAnaliseMercadoStatusProjetadoPipe: ClienteAnaliseMercadoStatusProjetadoPipe) { }

    /** Retorna o title para exibir no badge */
    getTitle(): string {
        return this.title ? this.title : this.createTitle();
    }

    /** Cria o title considerando se possui ou não a etapa de negociação da projeção informada */
    private createTitle(): string {
        return (this.idEtapaNegociacaoProjecao && this.nomeEtapaNegociacaoProjecao) ? this.nomeEtapaNegociacaoProjecao : this.clienteAnaliseMercadoStatusProjetadoPipe.transform(statusProjetadoEmNegociacao.id);
    }
}
